// API client for the Cloudflare Worker backend

const API_BASE = import.meta.env.VITE_API_URL || '';

async function apiFetch(path, options = {}) {
  if (!API_BASE) return null;

  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });

  if (!res.ok) return null;
  return res.json();
}

// Get user profile (pro status, purchases, stats)
export async function getUserProfile(clerkId) {
  return apiFetch(`/api/user?clerk_id=${encodeURIComponent(clerkId)}`);
}

// Create or update user on sign-in
export async function syncUser(clerkId, email, name) {
  return apiFetch('/api/user', {
    method: 'POST',
    body: JSON.stringify({ clerk_id: clerkId, email, name }),
  });
}

// Update game stats
export async function updateStats(clerkId, won) {
  return apiFetch('/api/user/stats', {
    method: 'POST',
    body: JSON.stringify({ clerk_id: clerkId, won }),
  });
}

// Check if user has played today's daily challenge
export async function getDailyResult(clerkId, date) {
  return apiFetch(`/api/daily/result?clerk_id=${encodeURIComponent(clerkId)}&date=${encodeURIComponent(date)}`);
}

// Submit daily challenge result
export async function submitDailyResult(clerkId, date, roundsSurvived, won) {
  return apiFetch('/api/daily/result', {
    method: 'POST',
    body: JSON.stringify({ clerk_id: clerkId, date, rounds_survived: roundsSurvived, won }),
  });
}

// Get daily leaderboard
export async function getDailyLeaderboard(date) {
  return apiFetch(`/api/daily/leaderboard?date=${encodeURIComponent(date)}`);
}
